(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.holding-report.view
    (:require
     [clojure.string :as string]
     [common.localization :as loc]
     [frontend.tenant-customizations :as tenant-customizations]
     [frontend.ui.component.grid.view :as grid]
     [frontend.ui.page.lp-portal.report.view :as report-view]
     [frontend.ui.page.lp-report-editor.common.event :as common-event]
     [frontend.ui.page.lp-report-editor.common.modal.notification-email-modal :as email-modal]
     [frontend.ui.page.lp-report-editor.common.modal.pdf-preview-modal :as pdf-preview-modal]
     [frontend.ui.page.lp-report-editor.common.view :refer [close-button
                                                            footer
                                                            preview-holding-pdf-page-button]]
     [frontend.ui.page.lp-report-editor.step-2-data-gathering.event :as step-event]
     [frontend.ui.page.lp-report-editor.step-2-data-gathering.fund-report.event :as fund-event]
     [frontend.ui.page.lp-report-editor.step-2-data-gathering.holding-report.event :as event]
     [frontend.ui.page.lp-report-editor.step-2-data-gathering.sub :as sub]
     [frontend.ui.page.lp-report-editor.style :as editor-style]
     [frontend.ui.page.lp-report-editor.sub :as editor-sub]
     [herb.core :refer [<class]]
     [re-frame.core :as rf]
     [ui.components.button.view :as button]))

(defn text-approver-buttons
  [holding-report rich-content-completed-amount]
  (let [show-amount? (tenant-customizations/capman?)]
    (case (:lp-report-holding/text-status holding-report)
      :lp-report-holding.publishing-status/wip
      [button/primary-solid
       {:on-click #(rf/dispatch [::event/submit-for-review-text (:db/id holding-report)])}
       (str (loc/tr :submit-for-review-text) (when show-amount?
                                               rich-content-completed-amount))]
      :lp-report-holding.publishing-status/pending-approval
      [:<>
       [button/danger-solid
        {:on-click #(rf/dispatch [::event/reject-text (:db/id holding-report)])}
        (loc/tr :reject-text)]
       [:div
        [button/primary-solid
         {:on-click #(rf/dispatch [::event/approve-text (:db/id holding-report)])}
         (loc/tr :approve-text)]]]
      :lp-report-holding.publishing-status/approved
      [button/secondary-hollow
       {:on-click #(rf/dispatch [::event/reject-text (:db/id holding-report)])}
       (loc/tr :return-for-editing-text)]
      [button/primary-solid
       {:on-click #(rf/dispatch [::event/submit-for-review-text (:db/id holding-report)])}
       (loc/tr :submit-for-review-text)])))

(defn data-approver-buttons
  [holding-report]
  (case (:lp-report-holding/data-status holding-report)
    :lp-report-holding.publishing-status/wip
    [button/primary-solid
     {:on-click #(rf/dispatch [::event/submit-for-review-data (:db/id holding-report)])}
     (loc/tr :submit-for-review-data)]
    :lp-report-holding.publishing-status/pending-approval
    [:<>
     [button/danger-solid
      {:on-click #(rf/dispatch [::event/reject-data (:db/id holding-report)])}
      (loc/tr :reject-data)]
     [:div
      [button/primary-solid
       {:on-click #(rf/dispatch [::event/approve-data (:db/id holding-report)])}
       (loc/tr :approve-data)]]]
    :lp-report-holding.publishing-status/approved
    [button/secondary-hollow
     {:on-click #(rf/dispatch [::event/reject-data (:db/id holding-report)])}
     (loc/tr :return-for-editing-data)]
    [button/primary-solid
     {:on-click #(rf/dispatch [::event/submit-for-review-data (:db/id holding-report)])}
     (loc/tr :submit-for-review-data)]))

(defn text-contributor-buttons
  [holding-report]
  (case (:lp-report-holding/text-status holding-report)
    :lp-report-holding.publishing-status/wip
    [button/primary-solid
     {:on-click #(rf/dispatch [::event/submit-for-review-text (:db/id holding-report)])}
     (loc/tr :submit-for-review-text)]
    :lp-report-holding.publishing-status/pending-approval
    [:<>
     [button/secondary-hollow
      {:on-click #(rf/dispatch [::event/reject-text (:db/id holding-report)])}
      (loc/tr :withdraw-submission-text)]]
    :lp-report-holding.publishing-status/approved
    nil
    ;; DEFAULT
    [button/primary-solid
     {:on-click #(rf/dispatch [::event/submit-for-review-text (:db/id holding-report)])}
     (loc/tr :submit-for-review-text)]))

(defn data-contributor-buttons
  [holding-report]
  (case (:lp-report-holding/data-status holding-report)
    :lp-report-holding.publishing-status/wip
    [button/primary-solid
     {:on-click #(rf/dispatch [::event/submit-for-review-data (:db/id holding-report)])}
     (loc/tr :submit-for-review-data)]
    :lp-report-holding.publishing-status/pending-approval
    [:<>
     [button/secondary-hollow
      {:on-click #(rf/dispatch [::event/reject-data (:db/id holding-report)])}
      (loc/tr :withdraw-submission-data)]]
    :lp-report-holding.publishing-status/approved
    nil
    ;; DEFAULT
    [button/primary-solid
     {:on-click #(rf/dispatch [::event/submit-for-review-data (:db/id holding-report)])}
     (loc/tr :submit-for-review-data)]))

(defn reject-data-email-modal
  [recipients on-reject-confirmed]
  (when-let [report-id @(rf/subscribe [::sub/holding-data-rejected?])]
    [email-modal/view
     {:on-hide!       (fn []
                        (rf/dispatch [::event/clear-notification report-id]))
      :recipients     recipients
      :header         (loc/tr :reject-data)
      :on-skip-email! (fn [_]
                        (rf/dispatch (vec (concat on-reject-confirmed [[] nil])))
                        (rf/dispatch [::event/clear-notification report-id]))
      :on-submit!     (fn [filtered-recipients message]
                        (rf/dispatch (vec (concat on-reject-confirmed
                                                  [filtered-recipients message])))
                        (rf/dispatch [::event/clear-notification report-id]))}]))

(defn reject-text-email-modal
  [recipients on-reject-confirmed]
  (when-let [report-id @(rf/subscribe [::sub/holding-text-rejected?])]
    [email-modal/view
     {:on-hide!       (fn []
                        (rf/dispatch [::event/clear-notification report-id]))
      :recipients     recipients
      :header         (loc/tr :reject-text)
      :on-skip-email! (fn [_]
                        (rf/dispatch (vec (concat on-reject-confirmed [[] nil])))
                        (rf/dispatch [::event/clear-notification report-id]))
      :on-submit!     (fn [filtered-recipients message]
                        (rf/dispatch (vec (concat on-reject-confirmed
                                                  [filtered-recipients message])))
                        (rf/dispatch [::event/clear-notification report-id]))}]))

(defn submit-data-email-modal
  [recipients on-submit-confirmed]
  (when-let [report-id @(rf/subscribe [::sub/holding-data-submitted?])]
    [email-modal/view
     {:on-hide!       (fn []
                        (rf/dispatch [::event/clear-notification report-id]))
      :recipients     recipients
      :header         (loc/tr :submit-for-review-data)
      :on-skip-email! (fn [_]
                        (rf/dispatch (vec (concat on-submit-confirmed [[] nil])))
                        (rf/dispatch [::event/clear-notification report-id]))
      :on-submit!     (fn [filtered-recipients message]
                        (rf/dispatch (vec (concat on-submit-confirmed
                                                  [filtered-recipients message])))
                        (rf/dispatch [::event/clear-notification report-id]))}]))

(defn submit-text-email-modal
  [recipients on-submit-confirmed rich-content-list-by-holding holding-id]
  (let [on-complete-richtext! (fn [report-id edit-path edit-value complete-path complete-status]
                                (rf/dispatch [::event/save-holding-report-text report-id
                                              edit-path edit-value
                                              complete-path complete-status]))
        on-complete-all! (fn [report-id _]
                           (rf/dispatch [::event/complete-remaining-texts report-id]))]
    (when-let [report-id @(rf/subscribe [::sub/holding-text-submitted?])]
      [email-modal/view
       {:on-hide!                 (fn []
                                    (rf/dispatch [::event/clear-notification report-id]))
        :on-complete-richtext!    on-complete-richtext!
        :on-complete-all!         on-complete-all!
        :report-rich-content-list rich-content-list-by-holding
        :holding-report-id        holding-id
        :recipients               recipients
        :header                   (loc/tr :submit-for-review-text)
        :on-skip-email!           (fn [_]
                                    (rf/dispatch (vec (concat on-submit-confirmed [[] nil])))
                                    (rf/dispatch [::event/clear-notification report-id]))
        :on-submit!               (fn [filtered-recipients message]
                                    (rf/dispatch (vec (concat on-submit-confirmed
                                                              [filtered-recipients message])))
                                    (rf/dispatch [::event/clear-notification report-id]))}])))
(defn step-footer
  [holding-report]
  (let [h-report-id (:db/id holding-report)
        text-approve-access? @(rf/subscribe [::sub/can-approve-holding-report-text?
                                             (:db/id holding-report)])
        text-edit-access? @(rf/subscribe [::sub/can-edit-holding-texts? h-report-id])
        data-approve-access? @(rf/subscribe [::sub/can-approve-holding-data?
                                             (:db/id holding-report)])
        data-edit-access? @(rf/subscribe [::sub/can-edit-holding-data? h-report-id])
        submit-text-recipients @(rf/subscribe [::sub/holding-text-submit-recipients h-report-id])
        reject-text-recipients @(rf/subscribe [::sub/holding-text-reject-recipients h-report-id])
        submit-data-recipients @(rf/subscribe [::sub/holding-data-submit-recipients h-report-id])
        reject-data-recipients @(rf/subscribe [::sub/holding-data-reject-recipients h-report-id])
        rich-content-list-by-holding @(rf/subscribe [::sub/rich-content-list-by-holding h-report-id])
        holding-rich-text-completed-amount @(rf/subscribe [::sub/holding-rich-text-completed-amount h-report-id])]
    [footer
     {:left-content
      [:<>
       [close-button {:on-click #(rf/dispatch [::step-event/reset])}]
       [:div
        [pdf-preview-modal/view
         {:on-close #(rf/dispatch [::common-event/close-pdf-preview])
          :report holding-report
          :holding-report? true}]
        [preview-holding-pdf-page-button
         {:on-click #(rf/dispatch [::common-event/open-holding-pdf-preview h-report-id false])}]]]
      :right-content

      [:<>
       (when (or text-edit-access? text-approve-access?)
         [:div.flex.gap-3
          [reject-text-email-modal reject-text-recipients [::event/reject-text-confirm h-report-id]]
          [submit-text-email-modal submit-text-recipients
           [::event/submit-for-review-text-confirm h-report-id]
           rich-content-list-by-holding
           h-report-id]
          (if text-approve-access?
            (text-approver-buttons holding-report holding-rich-text-completed-amount)
            (text-contributor-buttons holding-report))])

       (when (or data-approve-access? data-edit-access?)
         [:div.flex.gap-3
          [reject-data-email-modal reject-data-recipients [::event/reject-data-confirm h-report-id]]
          [submit-data-email-modal submit-data-recipients
           [::event/submit-for-review-data-confirm h-report-id]]
          (if data-approve-access?
            (data-approver-buttons holding-report)
            (data-contributor-buttons holding-report))])]}]))


(defn view
  []
  (let [holding-report-id @(rf/subscribe [::sub/holding-report-id])
        fund-report @(rf/subscribe [::editor-sub/lp-report])
        fund-report-id (:db/id fund-report)
        fund-report-ui-data @(rf/subscribe [::editor-sub/fund-report-ui-data fund-report-id])
        holding-report @(rf/subscribe [::sub/holding-report holding-report-id])
        holding-ui-data @(rf/subscribe [::editor-sub/holding-report-ui-data holding-report-id])
        data-not-approved? (not= (:lp-report-holding/data-status holding-report)
                                 :lp-report-holding.publishing-status/approved)
        can-edit? @(rf/subscribe [::sub/can-edit-holding-texts? holding-report-id])
        report-admin? @(rf/subscribe [::editor-sub/report-admin?])
        can-edit-footer? @(rf/subscribe [::sub/can-edit-holding-footers? holding-report-id])
        capman? (tenant-customizations/capman?)
        can-select-data-set? (if capman?
                               @(rf/subscribe [::sub/can-select-holding-chart? holding-report-id])
                               data-not-approved?)
        can-edit-chart? (if capman?
                          @(rf/subscribe [::sub/can-edit-holding-chart? holding-report-id])
                          data-not-approved?)
        save-text (fn [edit-path edit-value complete-path complete-status]
                    (rf/dispatch [::event/save-holding-report-text holding-report-id edit-path
                                  edit-value complete-path complete-status]))
        save-fund-text (fn [edit-path edit-value complete-path complete-status]
                         (rf/dispatch [::fund-event/save-fund-report-text fund-report-id
                                       edit-path edit-value
                                       complete-path complete-status]))
        save-editable-data (fn [edit-path edit-value on-success!]
                             (rf/dispatch [::event/save-holding-report-chart holding-report-id on-success! edit-path edit-value]))
        save-chart-configs-data (fn [edit-path edit-value on-success!]
                                  (rf/dispatch [::event/save-holding-report-chart-configs holding-report-id on-success! edit-path edit-value]))
        wip-data? (= :lp-report-holding.publishing-status/wip
                     (:lp-report-holding/data-status holding-report))]
    [:<>
     (when wip-data?
       [:div
        {:class (<class editor-style/page-watermark-container)}
        [:div
         {:class (<class editor-style/page-watermark)}
         (->> (take 2000 (repeat (loc/tr :draft-data)))
              (string/join " - "))]])
     [:div
      {:class (<class editor-style/page-body)}
      [grid/container {:breakpoint :xlarge}
       [grid/row {}
        [grid/column {:medium 1}]
        [grid/column {:medium 11}
         [report-view/holding-report-content
          {:holding-ui-data       holding-ui-data
           :fund-ui-data          fund-report-ui-data
           :holding-template-type (:lp-report-holding/template-type holding-report)
           :edit-mode?            can-edit?
           :chart-select?         can-select-data-set?
           :chart-edit?           can-edit-chart?
           :table-edit?           data-not-approved?        ;;TODO for now holding tables can be edited by everybody
           :table-select?         data-not-approved?
           :show-draft?           true
           :edit-mode-footer?     can-edit-footer?
           :save-text             save-text
           :save-fund-text        save-fund-text
           :report-admin?         report-admin?
           :save-chart            save-editable-data
           :save-table-data       save-editable-data
           :save-chart-configs    save-chart-configs-data}]]]]]
     [step-footer holding-report]]))
